import { TvChannel } from '@core/models/tv-channel.model';

export interface JsonContractPackChannel {
  id: number;
  packId?: number;
  channel: TvChannel;
  rate?: number;
  isSelected?: boolean;
}

export class ContractPackChannel {
  id: number;
  packId?: number;
  channel: TvChannel;
  rate?: number;
  isSelected?: boolean;

  constructor(jsonContractPackChannel: JsonContractPackChannel = null) {
    this.id = jsonContractPackChannel?.id;
    this.packId = jsonContractPackChannel?.packId;
    this.channel = jsonContractPackChannel?.channel;
    this.rate = jsonContractPackChannel?.rate;
  }
}
